module.exports = __webpack_public_path__ + "img/menu.dfc8f7a6.svg";